import { ProductionDeviationElement } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/UpcomingEventsModal/ProductionDeviationElement";
import { useProductionDeviations } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/UpcomingEventsModal/useProductionDeviation";
import { FC } from "react";
import { FailureMessage } from "shared/components/feedback/FailureMessage/FailureMessage";
import { NoDataMessage } from "shared/components/feedback/NoDataMessage/NoDataMessage";
import SkeletonLoader from "shared/components/feedback/SkeletonLoader/SkeletonLoader";
import { Stack } from "shared/components/Spor";

export const ProductionDeviationsList: FC = () => {
  const { status, data } = useProductionDeviations();

  if (status === "pending")
    return <SkeletonLoader skeletonType="internalEvents" />;
  if (status === "error") return <FailureMessage />;
  if (data.length === 0)
    return <NoDataMessage reason="Det er ikke registrert noen hendelser" />;

  return (
    <Stack gap="18px">
      {data.map((productionDeviation) => (
        <ProductionDeviationElement
          key={productionDeviation.reference}
          productionDeviation={productionDeviation}
        />
      ))}
    </Stack>
  );
};
